export default {
  title: "Budget",
  description: "Gestisci il tuo budget di matrimonio",
  totalBudget: "Budget Totale",
  totalSpent: "Totale Speso",
  remaining: "Rimanente",
  toPay: "Da pagare",
  exceeded: "Superato",
  noCategories: "Nessuna categoria configurata",
  percentage: "Percentuale",
  category: "Categoria",
  addExpense: "Aggiungi Spesa",
  editExpense: "Modifica Spesa",
  deleteExpense: "Elimina Spesa",
  expenseTitle: "Titolo Spesa",
  amount: "Importo",
  date: "Data",
  vendor: "Fornitore",
  notes: "Note",
  paid: "Pagato",
  pending: "In attesa",

  noExpenses: {
    title: "Nessuna spesa trovata",
    description: "Inizia aggiungendo la tua prima spesa"
  },
  monthlyExpenses: "Spese Mensili",
  sharing: {
    recipientEmail: "Email Destinatario",
    emailPlaceholder: "esempio@email.com",
    recipientName: "Nome Destinatario",
    namePlaceholder: "Nome",
    message: "Messaggio",
    messagePlaceholder: "Il tuo messaggio...",
    send: "Invia",
    cancel: "Annulla",
    title: "Condividi budget"
  },
  addFirstExpense: "Aggiungi la tua prima spesa",
  budgetOverview: "Panoramica Budget",
  expenseDetails: "Dettagli Spesa",
  save: "Salva",
  cancel: "Annulla",
  delete: "Elimina",
  edit: "Modifica",
  view: "Vedi",
  confirmDelete: "Sei sicuro di voler eliminare questa spesa?",
  expenseAdded: "Spesa aggiunta con successo",
  expenseUpdated: "Spesa aggiornata con successo",
  expenseDeleted: "Spesa eliminata con successo",
  budgetExceeded: "Budget superato",
  budgetWarning: "Avviso budget",
  budgetOnTrack: "Budget rispettato",
  setBudget: "Imposta Budget",
  editBudget: "Modifica Budget",
  budgetAmount: "Importo Budget",
  budgetSet: "Budget impostato con successo",
  budgetUpdated: "Budget aggiornato con successo",
  currency: "Valuta",
  estimatedCost: "Costo Stimato",
  actualCost: "Costo Reale",
  difference: "Differenza",
  overBudget: "Fuori Budget",
  underBudget: "Sotto Budget",
  onBudget: "Nel Budget",
  budgetAnalysis: "Analisi Budget",
  categoryBreakdown: "Ripartizione per Categoria",
  monthlySpending: "Spese Mensili",
  upcomingExpenses: "Spese Imminenti",
  recentExpenses: "Spese Recenti",
  budgetSummary: "Riepilogo Budget",
  totalAllocated: "Totale Allocato",
  totalUnallocated: "Totale Non Allocato",
  allocationPercentage: "Percentuale Allocazione",
  spendingTrend: "Tendenza Spesa",
  averageExpense: "Spesa Media",
  largestExpense: "Spesa Maggiore",
  smallestExpense: "Spesa Minore",
  expenseCount: "Numero di Spese",
  budgetUtilization: "Utilizzo Budget",
  projectedTotal: "Totale Proiettato",
  savingsGoal: "Obiettivo Risparmio",
  emergencyFund: "Fondo Emergenza",
  contingencyPercentage: "Percentuale Imprevisti",
  recommendedContingency: "Imprevisti Consigliati",
  import: "Importa",
  exportToCsv: "Esporta in CSV",
  exportToPdf: "Esporta in PDF",
  importFromCsv: "Importa da CSV",
  downloadTemplate: "Scarica Modello",
  budgetTemplate: "Modello Budget",
  customCategory: "Categoria Personalizzata",
  addCategory: "Aggiungi Categoria",
  categoryName: "Nome Categoria",
  categoryBudget: "Budget Categoria",
  categoryAdded: "Categoria aggiunta con successo",
  categoryUpdated: "Categoria aggiornata con successo",
  categoryDeleted: "Categoria eliminata con successo",
  duplicateCategory: "La categoria esiste già",
  search: "Cerca spese",
  filter: "Filtra",
  filterByCategory: "Filtra per Categoria",
  filterByStatus: "Filtra per Stato",
  filterByDate: "Filtra per Data",
  sortBy: "Ordina per",
  sortByDate: "Ordina per Data",
  sortByAmount: "Ordina per Importo",
  sortByCategory: "Ordina per Categoria",
  ascending: "Crescente",
  descending: "Decrescente",
  clearFilters: "Cancella Filtri",
  noFilterResults: "Nessuna spesa corrisponde ai tuoi filtri",
  showAll: "Mostra Tutto",
  showPaid: "Mostra Pagati",
  showPending: "Mostra In Attesa",
  thisMonth: "Questo Mese",
  lastMonth: "Mese Scorso",
  thisYear: "Quest'Anno",
  customRange: "Intervallo Personalizzato",
  from: "Da",
  to: "A",
  apply: "Applica",
  reset: "Reimposta",
  expenseCreated: "Spesa creata con successo",
  totalExpenses: "{{count}} spese",
  estimateBudget: "Stima budget",
  estimateBudgetShort: "Stima",
  newExpense: "Nuova spesa",
  add: "Aggiungi",
  overview: "Panoramica",
  distribution: "Distribuzione",
  expensesList: "Lista spese",
  exportPdf: "Esporta PDF",
  budgetUsed: "Budget utilizzato",
  loading: "Caricamento...",
  total: "Totale",
  confirmDeleteExpense: "Sei sicuro di voler eliminare questa spesa?",
  noExpensesText: "Nessuna spesa",
  importExpenses: "Importa spese",
  exportExpenses: "Esporta spese",
  budgetDetails: "Dettagli budget",
  budgetHistory: "Cronologia budget",
  budgetAnalytics: "Analisi budget",
  budgetSettings: "Impostazioni budget",
  spent: "Speso",

  categories: {
    venue: "Location",
    catering: "Catering",
    flowers: "Fiori",
    photography: "Fotografia",
    music: "Musica",
    attire: "Abbigliamento",
    rings: "Fedi",
    transportation: "Trasporti",
    decoration: "Decorazioni",
    invitations: "Inviti",
    gifts: "Regali",
    honeymoon: "Luna di miele",
    miscellaneous: "Varie",
    beauty: "Bellezza",
    other: "Altro",
    videography: "Videografia",
    accommodation: "Alloggio",
    stationery: "Cartoleria",
    general: "Generale",
    "Lieu et Réception": "Location e Ricevimento",
    "Animation et Photo": "Animazione e Foto",
    "Tenues et Accessoires": "Abiti e Accessori",
    title: "Categorie"
  },

  form: {
    title: "Titolo",
    amount: "Importo",
    category: "Categoria",
    date: "Data",
    vendor: "Fornitore",
    notes: "Note",
    paid: "Pagato",
    errors: {
      titleRequired: "Il titolo è obbligatorio",
      amountRequired: "L'importo è obbligatorio",
      categoryRequired: "La categoria è obbligatoria",
      amountPositive: "L'importo deve essere positivo"
    },
    description: "Descrizione",
    dueDate: "Data scadenza",
    status: "Stato",
    submit: "Salva",
    cancel: "Annulla",
    name: "Nome"
  },

  filters: {
    all: "Tutti",
    category: "Categoria",
    status: "Stato",
    vendor: "Fornitore",
    categoryPlaceholder: "Seleziona categoria",
    vendorPlaceholder: "Seleziona fornitore",
    budgetsearch: "Cerca spese",
    group: "Categoria",
    groupPlaceholder: "Seleziona una categoria...",
    tableAssigned: "Tavolo assegnato",
    allCategories: "Tutte le categorie",
    allStatuses: "Tutti gli stati",
    startDate: "Data inizio",
    endDate: "Data fine",
    minAmount: "Importo min (€)",
    maxAmount: "Importo max (€)",
    resetFilters: "Reimposta filtri",
    search: "Cerca una spesa",
    clear: "Cancella filtri",
    apply: "Applica",
    previous: "Precedente",
    next: "Successivo",
  },

  status: {
    paid: "Pagato",
    unpaid: "Non pagato",
    pending: "In attesa",
    cancelled: "Annullato"
  },

  table: {
    title: "Titolo",
    amount: "Importo",
    category: "Categoria",
    date: "Data",
    status: "Stato",
    description: "Descrizione",
    actions: "Azioni"
  },

  estimator: {
    title: "Stimatore di budget",
    guestCount: "Numero di ospiti",
    region: "Regione",
    services: "Servizi",
    lieu: "Location",
    traiteur: "Catering",
    photographie: "Fotografia",
    fleurs: "Fiori",
    musique: "Musica",
    tenues: "Abiti",
    calculate: "Calcola",
    estimatedBudget: "Budget stimato",
    validateBudget: "Convalida budget",
    adjustAmount: "Regola importo",
    modifyCriteria: "Modifica criteri",
    next: "Avanti",
    previous: "Indietro",
    ileDeFrance: "Île-de-France (Parigi)",
    paca: "PACA (Sud della Francia)",
    london: "Londra",
    otherUK: "Altro Regno Unito",
    madrid: "Madrid",
    barcelona: "Barcellona",
    berlin: "Berlino",
    munich: "Monaco",
    otherRegion: "Altra regione",
    style: "Che stile di matrimonio desideri?",
  },

  noExpensesFiltered: {
    title: "Nessuna spesa corrisponde ai tuoi filtri",
    description: "Prova a modificare i criteri di ricerca"
  },

  overrun: {
    title: "Budget superato",
    description: "Hai superato il tuo budget previsto"
  },

  success: {
    budgetUpdated: "Budget aggiornato con successo"
  },

  errors: {
    addExpense: "Errore durante l'aggiunta della spesa",
    deleteExpense: "Errore durante l'eliminazione della spesa",
    updateExpense: "Errore durante l'aggiornamento della spesa",
    loadExpenses: "Errore durante il caricamento delle spese",
    loadCategories: "Errore durante il caricamento delle categorie",
    loadWedding: "Errore durante il caricamento dei dati del matrimonio",
    loadTemplate: "Errore durante il caricamento del modello",
    updateBudget: "Errore durante l'aggiornamento del budget",
    noTemplateAvailable: "Nessun modello disponibile",
    noWeddingFound: "Nessun matrimonio trovato",
    loadData: "Errore durante il caricamento dei dati",
    noUser: "Nessun utente collegato",
    missingWeddingId: "ID matrimonio mancante"
  },

  pageExample: {
    title: "Gestione del Budget",
    subtitle: "Pianifica e monitora le spese del tuo matrimonio",
    connectedAs: "Collegato come",
    noAccess: "Nessun accesso",
    overviewDescription: "Panoramica generale delle tue spese e del budget rimanente",
    detailedExpenses: "Spese Dettagliate",
    detailedExpensesDescription: "Elenco completo di tutte le tue spese",
    share: "Condividi",
    venues: {
      receptionVenue: "Location Ricevimento",
      chateauVersailles: "Reggia di Versailles",
    },
    access: {
      readOnlyAccess: "Accesso in sola lettura - Impossibile modificare",
      advancedConfig: "Configurazione Avanzata",
      advancedConfigDescription: "Impostazioni e configurazione del budget",
      adminOnly: "Solo amministratore",
      adminZone: "Zona Amministrazione",
      adminZoneDescription: "Questa sezione contiene impostazioni sensibili accessibili solo agli amministratori.",
      exportData: "Esporta Dati",
      resetBudget: "Reimposta Budget",
      permissionsInfo: "Informazioni sui tuoi permessi",
      read: "Lettura",
      write: "Scrittura",
      delete: "Eliminazione",
      share: "Condivisione",
    },
    description: "Questo è un esempio di pagina budget con dati fittizi",
    accessLevel: "Livello di accesso",
    permissions: "Permessi",
    venue: {
      title: "Location",
      name: "Castello delle Rose",
      capacity: "Capienza: 150 persone",
      location: "Provenza, Francia",
      contact: "Contatto: +33 1 23 45 67 89"
    },
    admin: {
      title: "Amministrazione",
      exportData: "Esporta dati",
      importData: "Importa dati",
      backupData: "Backup dati",
      resetData: "Reimposta dati"
    },
    status: {
      connected: "Collegato",
      synchronized: "Sincronizzato",
      lastUpdate: "Ultimo aggiornamento: {{date}}"
    }
  },

  initialBudget: "Budget iniziale",
  used: "utilizzato",
  paymentStatus: "Stato Pagamenti",
  categoryProgress: "Progresso per Categoria",
  addExpenseLabel: "Aggiungi una spesa",

  expenses: {
    title: "Spese",
    add: "Aggiungi spesa",
    edit: "Modifica spesa",
    name: "Nome",
    amount: "Importo",
    category: "Categoria",
    date: "Data",
    paid: "Pagato",
    unpaid: "Non pagato",
    notes: "Note",
    vendor: "Fornitore",
    noExpenses: "Nessuna spesa",
    total: "Totale",
    filter: "Filtra",
    search: "Cerca",
    delete: "Elimina",
    confirm: "Conferma"
  },

  modal: {
    title: "Spesa",
    edit: "Modifica spesa",
    delete: "Elimina spesa",
    confirmDelete: "Sei sicuro di voler eliminare questa spesa?"
  },

  summary: {
    total: "Totale",
    spent: "Speso",
    remaining: "Rimanente",
    overBudget: "Eccesso",
    currency: "€"
  },

  analytics: {
    title: "Analisi budget",
    insights: {
      title: "Approfondimenti e tendenze",
      topCategory: {
        title: "Categoria principale",
        description: "{{category}} rappresenta il {{percentage}}% delle tue spese con {{amount}}"
      },
      overBudget: {
        title: "Budget superato",
        description: "Hai superato il tuo budget del {{percentage}}% ({{amount}})"
      },
      nearBudget: {
        title: "Budget quasi raggiunto",
        description: "Hai utilizzato il {{percentage}}% del tuo budget. Ti rimane {{remaining}}"
      },
      increasingTrend: {
        title: "Spese in aumento",
        description: "Le tue spese sono aumentate di {{amount}} questo mese ({{month}})"
      },
      decreasingTrend: {
        title: "Spese in diminuzione",
        description: "Le tue spese sono diminuite di {{amount}} questo mese ({{month}})"
      }
    },
    charts: {
      categoryDistribution: "Distribuzione per categoria",
      monthlyTrend: "Tendenza mensile",
      monthlySpending: "Spese mensili",
      cumulativeSpending: "Spese cumulative",
      averagePerCategory: "Media per categoria",
      averageSpending: "Media spese"
    },
    details: {
      title: "Statistiche dettagliate",
      transactions: "transazioni",
      average: "Media"
    },
    overview: "Panoramica",
    byCategory: "Per categoria",
    byMonth: "Per mese",
    trends: "Tendenze"
  },

  messages: {
    createSuccess: "Spesa aggiunta con successo",
    updateSuccess: "Spesa aggiornata con successo",
    deleteSuccess: "Spesa eliminata con successo",
    deleteConfirm: "Sei sicuro di voler eliminare questa spesa?",
    error: "Si è verificato un errore",
    budgetCreated: "Budget creato con successo",
    budgetUpdated: "Budget aggiornato con successo",
    budgetDeleted: "Budget eliminato con successo",
    expenseAdded: "Spesa aggiunta con successo",
    expenseUpdated: "Spesa aggiornata con successo",
    expenseDeleted: "Spesa eliminata con successo",
    categoryAdded: "Categoria aggiunta con successo",
    categoryUpdated: "Categoria aggiornata con successo",
    categoryDeleted: "Categoria eliminata con successo"
  },
};